import { useLocation } from "react-router-dom";
import { Breadcrumbs, Link, Stack } from "@mui/material";
import { NavigateNext } from "@mui/icons-material";
import { useTheme } from "@mui/material/styles";

export default function Breadcrumb({ navData }) {
  function findBreadcrumbPath(navData, pathSegments) {
    const fullPath = pathSegments.join("/");
    
    // 재귀적으로 path 속성으로 먼저 찾기
    function findByPath(items, parentPath = []) {
      for (const item of items) {
        if (item.path && fullPath.startsWith(item.path)) {
          const result = [...parentPath, item];
          
          // 자식이 있으면 더 구체적인 경로 찾기
          if (item.child && item.child.length > 0) {
            const childResult = findByPath(item.child, result);
            if (childResult) return childResult;
            
            // :id 자식 확인
            const pathParts = fullPath.split("/");
            const itemParts = item.path.split("/");
            if (pathParts.length > itemParts.length) {
              const idChild = item.child.find(c => c.key === ":id");
              if (idChild) return [...result, idChild];
            }
          }
          
          return result;
        }
        
        // 자식이 있으면 재귀
        if (item.child && item.child.length > 0) {
          const childResult = findByPath(item.child, [...parentPath, item]);
          if (childResult) return childResult;
        }
      }
      return null;
    }
    
    // 먼저 path 속성으로 찾기
    const pathResult = findByPath(navData);
    if (pathResult) return pathResult;
    
    // path 속성이 없으면 key 기반으로 찾기 (기존 로직)
    let path = [];
    let currentLevel = navData;
    for (const segment of pathSegments) {
      let match;
      if (currentLevel?.find) {
        match = currentLevel.find((item) => item.key === segment);
      }
      if (match) {
        path.push(match);
        currentLevel = match.child;
      } else {
        break;
      }
    }

    return path;
  }

  const location = useLocation();
  const pathSegments = location.pathname.split("/").filter(Boolean);
  const nP = pathSegments.map((p) => {
    if (Number.isNaN(Number(p))) {
      return p;
    }
    return ":id";
  });
  const theme = useTheme();
  const breadcrumbPath = findBreadcrumbPath(navData, nP);
  
  return (
    <Breadcrumbs
      aria-label="breadcrumb"
      sx={{
        color: theme.palette.common.darkGrey,
        ".MuiBreadcrumbs-separator": {
          margin: "0 4px !important",
        },
      }}
      separator={
        <NavigateNext
          fontSize="20px"
          sx={{ verticalAlign: "middle", color: "#79818A" }}
        />
      }
    >
      {breadcrumbPath
        .filter((item) => item.key !== "modify")
        .map((item, index, filteredArray) => {
          const isLast = index === filteredArray.length - 1;
          const originalIndex = breadcrumbPath.indexOf(item);
          const to = "/" + pathSegments.slice(0, originalIndex + 1).join("/");
          return (
            <Link
              sx={{
                fontSize: "16px !important",
                fontWeight: isLast ? "600" : "500",
                color: isLast ? "black !important" : "#79818A",
              }}
              key={item.key}
              to={to}
              underline={"none"}
              color={isLast ? "black" : "#79818A"}
            >
              {item.name}
            </Link>
          );
        })}
    </Breadcrumbs>
  );
}
